module.exports = __webpack_public_path__ + "image/footer_logo2.png";